module.exports = __webpack_public_path__ + "img/ExpirySyncDateEditor.39641d59.png";